import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { updateSearchManager } from './types';

import { requestUpdateSearchManagerSuccess, requestUpdateSearchManagerFailure } from './reducer';

const logger = new Logger('Saga:FundingSearch:SearchManager');

export function* requestUpdateSearchManagerSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.patch,
      routerService.generate('api.search_manager.funding_search_manager_update', {
        fundingSearchId: action.fundingSearchId,
        userId: action.userId,
      }),
    );

    yield put(requestUpdateSearchManagerSuccess(action.fundingSearchId, response.data));
  } catch (error) {
    logger.error('Failed to update search manager with the following error', error);
    yield put(requestUpdateSearchManagerFailure(action.fundingSearchId, error));
  }
}

export default function* searchManagerSaga() {
  return yield all([takeLatest(updateSearchManager.request, requestUpdateSearchManagerSaga)]);
}
